export enum InvoicePeriodizationType {
    UNSPECIFIED = 'unspecified',
    INVOICE_DATE = 'invoice-date',
    INVOICE_DUE_DATE = 'invoice-due-date',
}
